"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polyfill = exports.LightMapImpl = void 0;
class LightMapImpl {
    constructor() {
        this.record = [];
    }
    has(key) {
        return this.record.map(([_key]) => _key).indexOf(key) >= 0;
    }
    get(key) {
        const [entry] = this.record.filter(([_key]) => _key === key);
        if (entry === undefined) {
            return undefined;
        }
        return entry[1];
    }
    set(key, value) {
        const [entry] = this.record.filter(([_key]) => _key === key);
        if (entry === undefined) {
            this.record.push([key, value]);
        }
        else {
            entry[1] = value;
        }
        return this;
    }
    delete(key) {
        const index = this.record.map(([key]) => key).indexOf(key);
        if (index < 0) {
            return false;
        }
        this.record.splice(index, 1);
        return true;
    }
    keys() {
        return this.record.map(([key]) => key);
    }
}
exports.LightMapImpl = LightMapImpl;
Symbol.toStringTag;
exports.Polyfill = typeof Map !== "undefined" ? Map : LightMapImpl;
